export const RESPONSE_MESSAGE_TYPES = {
    ACCORDION: "accordion",
    CAROUSEL: "carousel",
    FILE_DOWNLOAD: "file_download",
    VIDEO: "video",
    IMAGE: "image",
    RATING: "rating",
    CSAT: "csat",
};
export const SESSION_STORAGE_KEYS = {
    CHAT_HISTORY: "rasa-chat-history",
};
export const SENDER = {
    BOT: "bot",
    USER: "user",
};
export const SOCKET_IO_RECONNECTION_DELAY = 4000;
//# sourceMappingURL=constants.js.map